import "./index.css"; // Importation du CSS global
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import HeaderSection from "./HeaderSection";
import Headerartistique from "./Headerartistique";

import PresentationSection from "./PresentationSection";
import PresentationArt from "./PresentationArt";

import MaterialSection from "./MaterialSection";
import ExperienceSection from "./ExperienceSection";
import Podcast from "./Podcast";  // Importation du composant SoundExample
import MediaSection from "./MediaSection";
import MediaSectionart from "./MediaSectionart";
import Audiovisuel from "./Audiovisuel";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";




// Page Technicien
function Technicien() {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <Helmet>
        <title>Technicien</title>
        <meta
          name="description"
          content="Inge son documentaire, studio, spectacle, post-production, Assistant Son Fiction"
        />
      </Helmet>
      <HeaderSection scrollToSection={scrollToSection} />
      <PresentationSection />
      <div className="separator"></div>

      <ExperienceSection />
      <div className="separator"></div>
      <MaterialSection />
      <div className="separator"></div>
      <MediaSection />
      <div className="separator"></div>

      <Footer />


    </div>
  );
}

// Page Artistique
function Artistique() {
  return (
    <div className="App">
      <Helmet>
        <title>Artiste</title>
        <meta
          name="description"
          content="Créateur d'imaginaires sonores, compositeur, ateliers, créations participatives"
        />
      </Helmet>
      <Headerartistique />
      <div className="separator"></div>
      <PresentationArt />
      <div className="separator"></div>
      <Podcast />
      <div className="separator"></div>
      <Audiovisuel />
      <div className="separator"></div>
      <MediaSectionart />
      <div className="separator"></div>
      <Footer />
    </div>
  );
}

// App principale
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/technicien" element={<Technicien />} />
        <Route path="/artistique" element={<Artistique />} />
      </Routes>
    </Router>
  );
}

export default App;
